import { createSelector } from "reselect";

const historySelector = (state) => state.visitors.history;

export const getHistoryList = createSelector([historySelector], (state) => state.list);
